import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Page from "../components/Page";
import ReportExportWrapper from "../components/ReportExportWrapper";
import { IconFilter } from "@tabler/icons-react";
import { useGenericReport } from "../controllers/reports.controller";

export default function GenericReportPage() {
  const { reportType } = useParams();

  const formattedTitle = reportType.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  const [dateRange, setDateRange] = useState("Last 30 Days");

  const { data, isLoading } = useGenericReport({ reportType, dateFilter: dateRange });

  const columns = data?.columns || [];
  const tableData = data?.tableData || [];
  const summaryData = data?.summaryData || {};

  return (
    <Page>
      <ReportExportWrapper
        title={`${formattedTitle} Report`}
        reportType={formattedTitle}
        dateRange={dateRange}
        filters="Default"
        columns={columns}
        tableData={tableData}
        summaryData={summaryData}
      >
        <div className="flex justify-between items-center mb-6 print:hidden">
          <div className="flex gap-2 items-center bg-gray-50 border border-gray-100 dark:bg-gray-800 dark:border-gray-700 p-1.5 rounded-xl text-sm font-bold">
            <span className="px-3 text-gray-500">Date Range:</span>
            <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="bg-transparent border-none outline-none text-restro-green font-black">
              <option>Today</option>
              <option>Yesterday</option>
              <option>Last 7 Days</option>
              <option>Last 30 Days</option>
              <option>This Month</option>
              <option>This Year</option>
            </select>
          </div>
          <button className="btn btn-sm btn-ghost gap-2">
            <IconFilter size={16} /> Advanced Filters
          </button>
        </div>

        {/* Summary Cards */}
        {isLoading ? (
          <div className="flex justify-center p-8"><span className="loading loading-spinner text-restro-green"></span></div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {Object.entries(summaryData).map(([key, value], idx) => (
                <div key={idx} className="p-6 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <p className="text-xs font-black text-gray-500 uppercase tracking-widest mb-2">{key}</p>
                  <h3 className="text-3xl font-black">{value}</h3>
                </div>
              ))}
            </div>

            {/* Standard Table View */}
            <div className="overflow-x-auto border border-gray-100 dark:border-gray-800 rounded-2xl">
              <table className="w-full text-left text-sm">
                <thead className="bg-gray-50 dark:bg-gray-800 border-b border-gray-100 dark:border-gray-700">
                  <tr>
                    {columns.map((c, i) => <th key={i} className="p-4 font-bold text-gray-500 uppercase tracking-wider">{c.header}</th>)}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {tableData.length === 0 ? (
                    <tr><td colSpan={columns.length || 1} className="p-4 text-center text-gray-500">No data available for this period.</td></tr>
                  ) : (
                    tableData.map((row, i) => (
                      <tr key={i} className="hover:bg-gray-50/50 dark:hover:bg-gray-800/50 transition">
                        {columns.map((c, j) => (
                          <td key={j} className={`p-4 ${j===0 ? 'font-bold' : ''}`}>{row[c.key] || "-"}</td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}


      </ReportExportWrapper>
    </Page>
  );
}
